import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const AllInsidents = lazy(() => import('./AllIncidents'))
const SignleIncident = lazy(() => import('./SingleIncidentSteps'))
//const SignleIncident = lazy(() => import('./SingleIncident'))
const CreateIncident = lazy(() => import('./CreateIncident'))
const MyAssignedTasks = lazy(() => import('./MyAssignedTasks'))
const InsidentsRoutes = [
    {
        path: '/incidents',
        component: AllInsidents,
        auth: authRoleAccess.all_incidents_view,
    },
    {
        path: '/create_incidents',
        component: CreateIncident,
        auth: authRoleAccess.all_incidents_view,
    },
    {
        path: '/my_assigned_tasks',
        component: MyAssignedTasks,
        auth: authRoleAccess.my_assigned_tasks_view,
    },
     {
        path: '/incident/:id',
        component: SignleIncident,
        auth: authRoleAccess.all_incidents_view,
    },
    
]

export default InsidentsRoutes 